import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import * as React from "react";
import { NavLink } from "..";

var NavItem = function NavItem(_ref) {
  var hideOverlay = _ref.hideOverlay,
      children = _ref.children,
      item = _objectWithoutProperties(_ref, ["hideOverlay", "children"]);

  var content = children && children.length ? React.createElement("ul", null, children.map(function (subItem, i) {
    return React.createElement(NavItem, _extends({
      key: i
    }, subItem));
  })) : null;
  return React.createElement("li", null, React.createElement(NavLink, {
    item: item,
    onClick: hideOverlay
  }), content);
};

export default NavItem;